import{useState as r,useCallback as t}from"react";function n(){var n=r(0),o=n[0],e=n[1];return t(function(){return e(o+1)},[o])}export{n as useForceUpdate};
//# sourceMappingURL=index.m.js.map
